import { createSelector } from 'reselect'
import getCustomer from './getCustomer'

export default createSelector(
  getCustomer,
  (customer) => customer && customer.metadata && customer.metadata.locations,
)
